import { helper } from '@ember/component/helper';
export const _labelExtract = (options, value) => {
  return (
    options.find(
      (option) =>
        String(option.value)?.toLowerCase() === String(value)?.toLowerCase(),
    )?.label ?? ''
  );
};
export default helper(function labelExtract([options, value] /*, named*/) {
  return _labelExtract(options, value);
});
